import SalesTypeTable from "./SalesTypeTable";

const SalesType = () => {
  return (
    <>
      <SalesTypeTable />
    </>
  );
};

export default SalesType;
